/**
 * @fileoverview FAQ page — static content rendered via Preact.
 * Content is locale-aware: language is detected from the URL pathname.
 */

import { BasePage } from './BasePage.js';
import { tapProps } from '../../utilities/tapProps.js';
import { faqTranslations } from '../../i18n/faq.js';
import { currentLang } from '../../i18n/lang.js';

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

function FaqView() {
    const navigate = (path: string) => (window as any).__appNavigate?.(path);
    const { heading, faqs } = faqTranslations[currentLang];

    return (
        <div class="page-inner">
            <div class="page-header">
                <button class="page-back-icon" aria-label="Back" {...tapProps(() => navigate('/'))}>
                    <span class="material-icons">arrow_back</span>
                </button>
                <h1>{heading}</h1>
            </div>
            {faqs.map(({ question, answer }) => (
                <div
                    class="faq-item"
                    itemscope
                    itemprop="mainEntity"
                    itemtype="https://schema.org/Question"
                >
                    <h2 itemprop="name">{question}</h2>
                    <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                        <p itemprop="text">{answer}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

// ---------------------------------------------------------------------------
// Page class
// ---------------------------------------------------------------------------

export class FaqPage extends BasePage {
    constructor() {
        super('faqPage');
    }

    protected override async render(): Promise<void> {
        this.renderPreact(<FaqView />);
    }
}
